import { initWasm } from '@resvg/resvg-wasm'
import wasmUrl from '@resvg/resvg-wasm/index_bg.wasm?url'

let initPromise: Promise<boolean>

export function initResvg() {
  if (!initPromise) {
    initPromise = fetch(wasmUrl)
      .then(r => {
        if (!r.ok) throw new Error(`Failed to fetch resvg wasm: ${r.status}`)
        return r.arrayBuffer()
      })
      .then(buf => initWasm(buf))
      .then(() => true)
  }
  return initPromise
}
